import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';

/**
 * The list of tabs on this page
 */
export enum AdmissionsCommitmentsPageTabId {
	Commitments = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum AdmissionsCommitmentsPageViewId {
	Commitments = 1,
}


@Injectable({ providedIn: 'root' })
export class AdmissionsCommitmentsService extends PageTabsLayoutPageService<AdmissionsCommitmentsPageTabId, AdmissionsCommitmentsPageViewId> {
	private static readonly _viewDroplistItems: DroplistItem<never, AdmissionsCommitmentsPageViewId>[] = [
		{
			uniqueId: AdmissionsCommitmentsPageViewId.Commitments,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Commitments',
				hideText: 'never',
			},
			customSort: '1-Commitments'
		},
	];


	constructor() {
		super(AdmissionsCommitmentsService._viewDroplistItems, AdmissionsCommitmentsService.name, AdmissionsCommitmentsPageTabId.Commitments, AdmissionsCommitmentsPageViewId.Commitments);
	}

	public get viewId() {
		return AdmissionsCommitmentsPageViewId;
	}

}